import React, { useState } from 'react';

import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from '@gogame/components';
import { useIsAllowed } from '@gogame/permissions';

import BulkRequest from './components/BulkRequest';
import AddRequest from './components/Request';
import ReferralRequest from './components/ReferralRequest';

const MODE_SINGLE = 'single';
const MODE_REFERRAL = 'referral';
const MODE_BULK = 'bulk';

const permissionReferralProgram = 51;

const PlayersInformationActions = ({ onSubmit }) => {
  const isAllowed = useIsAllowed();

  const [mode, setMode] = useState(MODE_SINGLE);

  const handleChangeButtonGroup = (_, value) => {
    if (value) {
      setMode(value);
    }
  };

  return (
      <Stack flex={1} >
        <Stack pr={2} pl={2} pt={2} pb={1}>
          <ToggleButtonGroup
            size={'small'}
            color={'primary'}
            exclusive={true}
            onChange={handleChangeButtonGroup}
            value={mode}
          >
            <ToggleButton value={MODE_SINGLE}>Single</ToggleButton>
            {isAllowed(permissionReferralProgram) ? (
              <ToggleButton value={MODE_REFERRAL}>Referral</ToggleButton>
            ) : null}
            <ToggleButton value={MODE_BULK}>Bulk</ToggleButton>
          </ToggleButtonGroup>
        </Stack>

        {mode === MODE_SINGLE ? <AddRequest onSubmit={onSubmit} /> : null}
        {mode === MODE_REFERRAL ? <ReferralRequest onSubmit={onSubmit} /> : null}
        {mode === MODE_BULK ? <BulkRequest /> : null}

      </Stack>
  );
};

export default PlayersInformationActions;
